import { create } from 'zustand';
export const useAgreementsAiSearchStore = create((set)=>({
        filter: null,
        lastQuery: '',
        isSubmitting: false,
        filterEditedSinceLastSearch: false,
        errorCode: null,
        abortInFlight: null,
        setSubmitting: (submitting)=>set({
                isSubmitting: submitting
            }),
        setAbortInFlight: (abort)=>set({
                abortInFlight: abort
            }),
        setFilter: (filter, lastQuery)=>set({
                filter,
                lastQuery,
                errorCode: null,
                filterEditedSinceLastSearch: false
            }),
        clearFilter: ()=>{
            const abort = useAgreementsAiSearchStore.getState().abortInFlight;
            abort === null || abort === void 0 ? void 0 : abort();
            set({
                filter: null,
                lastQuery: '',
                errorCode: null,
                isSubmitting: false,
                abortInFlight: null,
                filterEditedSinceLastSearch: false
            });
        },
        setError: (code)=>set({
                errorCode: code
            })
    }));
